import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { AuthService } from '../../../../core/services/auth.service';

import { FreightExchange } from '../../../../shared/objects/freight-exchange/freight-exchange';
import { BidInfo } from '../../../../shared/objects/freight-exchange/bidInfo';

@Injectable()
export class FreightExchangeService {
  private static shouldUpdate: Subject<void> = new Subject();
  public static shouldUpdate$() {
    return this.shouldUpdate.asObservable();
  }
  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
  ) {}

  public static updateFreightList() {
    this.shouldUpdate.next();
  }

  public getAllFreightExchanges(): Observable<FreightExchange[]> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.get<FreightExchange[]>(
      `${environment.freightExchangeServiceUrl}/getOrders`,
      { headers },
    );
  }

  public getAllFreightExchangesNumber(): Observable<number> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.get<number>(
      `${environment.freightExchangeServiceUrl}/getOrdersNumber`,
      { headers },
    );
  }

  public getFreightExchange(orderId: string): Observable<FreightExchange> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.get<FreightExchange>(
      `${environment.freightExchangeServiceUrl}/getOrder/${orderId}`,
      { headers },
    );
  }

  public addBid(bid: BidInfo): Observable<BidInfo> {
    const headers = this.authService.getBearerRequestHeaders();
    return this.httpClient.put<BidInfo>(
      `${environment.freightExchangeServiceUrl}/saveBid/${bid.orderId}`,
      bid,
      { headers },
    );
  }
}
